import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { AnalyticsCategory, AnalyticsService } from "../../../services/analytics.service";
import { GeolocationService } from "../../../services-vue/geolocation.service";
import eventBus from "../../../utilities/eventBus";

import TypeaheadInput from "../../vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";

export enum GetZipEvents {
    Changed = "app:zip:changed",
    Canceled = "app:zip:canceled"
}

export default defineComponent({
    inject: ["dialogRef"],
    components: {
        TypeaheadInput
    },

    data() {
        return {
            dialogReference: this.dialogRef as any,
            isCurrent: false,
            _analytics: null,
            _geolocationService: null,
            _isChange: false,
            zipError: false,
            options: null,
            zip: "",
            automaticUpdate: true,
            city: "",
            state: "",
            showEditZipCodeInput: false,
            showLocation: true
        };
    },
    created() {
        this._analytics = Container.instance.get(AnalyticsService);
        this._geolocationService = Container.instance.get(GeolocationService);
    },
    mounted() {
        this.options = this.dialogReference.data.locationData.locations;
        this.city = this.options.city;
        this.state = this.options.state;
        this.isCurrent = this.dialogReference.data.locationData.celsius;
    },
    methods: {
        cancel() {
            this.dialogReference.close();
        },

        async save() {
           await this.isValidZip();
           if(!this.zipError){
            this.dialogReference.close({ success: true, isCelOrFah: this.isCurrent });
           }
        },

        setIsCurrent(value: boolean) {
            this.isCurrent = value;
        },

        async isValidZip() {
            let newValue: string = this.zip.toString().trim();
            if (newValue) {
                if (newValue.length === 5 && /^\d+$/.test(newValue)) {
                    this.zipError = false;
                    const data = {
                        zipChanged: true,
                        zip: this.zip
                    };
                    eventBus.emit(GetZipEvents.Changed, this.zip);
                    const response = await this._geolocationService.getCoordinatesByZip(this.zip);
                    this.showLocation = true;
                    this.showEditZipCodeInput = false;
                    this._analytics.logEvent({
                        category: AnalyticsCategory.AxxessPlannerEditLocation,
                        action: "Submitted"
                    });
                } else {
                    this.zip = "";
                    this.zipError = true;
                }
            }
        },

        clearZip(): void {
            this.zip = "";
        },
        zipNotEntered(): void {
            this.showEditZipCodeInput = false;
            this.showLocation = true;
            this.automaticUpdate = true;
            this.zip = "";
            $("#automatic-update").prop("checked", true);
        },

        showEditZipCode() {
            this.showEditZipCodeInput = true;
            this.showLocation = false;
        }
    }
});
